module.exports = __webpack_public_path__ + "img/ofs-i-qixiutong-shuzihua.9e7836ed.png";